module.exports = __webpack_public_path__ + "img/level-pool.4ad0d5a.webp";